import { render, staticRenderFns } from "./CustomerInfiniteList.vue?vue&type=template&id=1f080680&scoped=true&lang=pug&"
import script from "./CustomerInfiniteList.vue?vue&type=script&lang=js&"
export * from "./CustomerInfiniteList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfiniteList.vue?vue&type=style&index=0&id=1f080680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f080680",
  null
  
)

export default component.exports